export const showFrom = "HzYC2b";
export default {showFrom};